export default "__VITE_ASSET__6d98abb5__"